import Registered from './Registered';
export default Registered;
